import { render, staticRenderFns } from "./membership-categories.vue?vue&type=template&id=796f6dd2&"
import script from "./membership-categories.vue?vue&type=script&lang=ts&"
export * from "./membership-categories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports